function change_teammemberKategorie() {
  filter_teammemberKategorie()
}
document.addEventListener("DOMContentLoaded", filter_teammemberKategorie);

function filter_teammemberKategorie() {
  const selectKategorie = document.getElementById("teammemberKategorie");
  const teamMembers = document.querySelectorAll("[class^=teammemberKategorien_]");
  teamMembers.forEach((teamMember) => {
    const teamMembersKategorien = teamMember.className.replace("teammemberKategorien_", "");
    const teamMembersKategorienArray = teamMembersKategorien.split(",");
    const contains = teamMembersKategorienArray.includes(selectKategorie.value);

    teamMember.style.display = contains ? 'block' : 'none';
  });
}